import Vue from 'vue';
import Progress from '@/components/copyright/basics/progress/index.vue'
let $vm

const plugin = {
  install (vue, pluginOptions = {}) {
    const TsaProgress = vue.extend(Progress)
    if (!$vm) {
      $vm = new TsaProgress({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const progress = {
      show (options = {}) {
        $vm.show = true
      },
      update (val) {
        $vm.update(val)
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaProgress) {
      vue.prototype.$TsaProgress = progress
    }
  }
}
export default plugin